module.exports = __webpack_public_path__ + "2f94a45ad7a08050f280a9fd1dd4af3c.png";